import { useDialog } from '@/services/useDialog'

const { openDialog } = useDialog()

export const useProfileDialog = () => {

  const openProfileDialog = () => {
    openDialog("profile")
  }

  return {
    openProfileDialog,
  }
}
